import { useEffect, useState } from 'react';
import { getDeploymentVersion } from '../../utils/deploymentVersion';

const DEPLOYMENT_VERSION_KEY = 'deploymentVersion';

interface DeploymentDetectorProps {
  children: React.ReactNode;
}

/**
 * Component that detects deployment changes and handles authentication state
 * This helps prevent users from getting stuck with invalid tokens after deployments
 */
export const DeploymentDetector: React.FC<DeploymentDetectorProps> = ({ children }) => {
  const [deploymentVersion, setDeploymentVersion] = useState<string>('');

  useEffect(() => {
    const currentVersion = getDeploymentVersion();
    setDeploymentVersion(currentVersion);

    try {
      // Passive marker only: never force reload from here.
      localStorage.setItem(DEPLOYMENT_VERSION_KEY, currentVersion);
    } catch {
      // Ignore write failures; app can still render.
    }
  }, []);

  // Don't render children until we've checked deployment status
  if (!deploymentVersion) {
    return null;
  }

  return <>{children}</>;
};
